import { useState, useEffect } from 'react';
import { useAccessibility } from '../../../context/AccessibilityContext/AccessibilityContext';
import Block from '../../../components/Block/Block';
import FadeIn from '../../../components/FadeIn/FadeIn';
import Button from '../../../components/Button/Button';
import style from './programblock.module.scss';

const ProgramBlock = ({ program, onSignUpClick }) => {
    const [isMobile, setIsMobile] = useState(false);
    const { settings: { contrast } } = useAccessibility();

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    const formatSchedule = (schedules) => {
        if (!schedules || schedules.length === 0) return 'Расписание не указано';
        
        return schedules.map(schedule => {
            if (!schedule.WeekDay || !schedule.StartTime || !schedule.EndTime) {
                return 'Данные отсутствуют';
            }
            return `${schedule.WeekDay} ${schedule.StartTime.slice(0, 5)}-${schedule.EndTime.slice(0, 5)}`;
        }).join(', ');
    };

    const handleSignUpClick = () => {
        if (onSignUpClick && program) {
            onSignUpClick({
                program: program,
                branches: program.branches?.data || []
            });
        }
    };

    if (!program) return null;

    return (
        <Block
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            width={isMobile ? '100%' : '75%'}
            height='fit-content'
            background={contrast !== 'default' ? 'var(--bg-primary)' : '#fff'}
            header='СПОРТИВНЫЕ ПРОГРАММЫ'
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.programCard}>
                        <div className={style.programDetails}>
                            <div className={style.programHeader}>
                                <h3 className={style.programTitle}>{program.Title || 'Без названия'}</h3>
                                <span
                                    style={{
                                        color: '#fff',
                                        background: contrast === 'default' ? '#1d3e8c' : '#000',
                                    }}
                                    className={style.programSport}
                                >
                                    {program.sport?.data?.attributes?.Title || 'Спорт'}
                                </span>
                            </div>
                            
                            <div className={style.programMeta}>
                                <div className={style.metaGroup}>
                                    <h4 className={style.metaTitle}>Основная информация</h4>
                                    <div className={style.metaItem}>
                                        <strong>Стоимость:</strong> {program.Price || 'Не указана'}
                                    </div>
                                    {program.Schedule && program.Schedule.length > 0 && (
                                        <div className={style.metaItem}>
                                            <strong>Расписание:</strong> {formatSchedule(program.Schedule)}
                                        </div>
                                    )}
                                </div>

                                {program.coaches?.data && program.coaches.data.length > 0 && (
                                    <div className={style.metaGroup}>
                                        <h4 className={style.metaTitle}>Тренеры</h4>
                                        {program.coaches.data.map((coach, index) => (
                                            <div key={coach.id || index} className={style.coachItem}>
                                                <div>
                                                    <strong>
                                                        {coach.attributes?.LastName || ''} 
                                                        {coach.attributes?.FirstName || ''} 
                                                        {coach.attributes?.PatronymicName || ''}
                                                    </strong>
                                                </div>
                                                <div>Опыт: {coach.attributes?.Experience || 'Не указан'}</div>
                                                <div>Достижения: {coach.attributes?.Achievements || 'Не указаны'}</div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {program.branches?.data && program.branches.data.length > 0 && (
                                    <div className={style.metaGroup}>
                                        <h4 className={style.metaTitle}>Филиалы</h4>
                                        {program.branches.data.map((branch, index) => (
                                            <div key={branch.id || index} className={style.branchItem}>
                                                <div><strong>{branch.attributes?.Title || 'Без названия'}</strong></div>
                                                <div>Адрес: {branch.attributes?.Address || 'Не указан'}</div>
                                                <div>Телефон: {branch.attributes?.Phone || 'Не указан'}</div>
                                                <div>Email: {branch.attributes?.Email || 'Не указан'}</div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {program.Description && (
                                <div className={style.programDescription}>
                                    <h4 className={style.descriptionTitle}>Описание программы</h4>
                                    <p>{program.Description}</p>
                                </div>
                            )}

                            {program.sport?.data?.attributes?.Description && (
                                <div className={style.programDescription}>
                                    <h4 className={style.descriptionTitle}>
                                        О {program.sport.data.attributes.Title || 'виде спорта'}
                                    </h4>
                                    <p>{program.sport.data.attributes.Description}</p>
                                </div>
                            )}

                            <Button
                                width={isMobile ? '100%' : 'fit-content'}
                                height='fit-content'
                                text='Записаться'
                                color={contrast !== 'default' ? 'var(--bg-primary)' : '#fff'}
                                background={contrast !== 'default' ? 'var(--text-primary)' : '#1d3e8c'}
                                fontFamily='Roboto, sans-serif'
                                fontSize='0.9rem'
                                fontWeight='600'
                                padding='0.8rem 1.5rem'
                                margin='1rem 0 0 0'
                                onClick={handleSignUpClick}
                            />
                        </div>
                    </div>
                </div>
            </FadeIn>
        </Block>
    );
};

export default ProgramBlock;